import { Button, Space, message } from 'antd'
import { useToken } from 'app/hooks'
import React from 'react'
import API from 'utils/api'
import { useTradeModalStore } from '../hooks/trade/modalStore'

const DeleteGroup = ({ data, mutate }) => {
	const { data: modalStore, mutate: mutateModalStore } = useTradeModalStore()
	const { data: token } = useToken()
	return (
		<Space.Compact>
			<Button
				size="small"
				onClick={() => {
					API.send(
						'DELETE',
						'/admin/usergroup/' + data?.id,
						token + '',
						{}, 
						false
					).then(res => {
						if(res.result.success){
							mutate()
							message.success('그룹 삭제 완료')
						}else{
							message.error('그룹 삭제 실패')
						}
					}).catch(err => {
						message.error('그룹 삭제 실패')
					})
				}}>
				삭제
			</Button>
		</Space.Compact>
	)
}

export default DeleteGroup
